import { Box } from '@mui/system';
import References from './References';

const PDFViewer = () => {
  return (
    <>
      <Box sx={{ mt: '2rem' }}>
        <iframe
          src='https://cdn.flipsnack.com/widget/v2/widget.html?hash=7nqv8mmxu3'
          width='100%'
          height='480'
          seamless='seamless'
          scrolling='no'
          frameBorder='0'
          allowFullScreen
          allow='autoplay; clipboard-read; clipboard-write'
          title='whitepaper'></iframe>
      </Box>
      <References />
    </>
  );
};

export default PDFViewer;
